import React from 'react';

function ProfileNotifications() {
  return <div></div>;
}

export default ProfileNotifications;
